import { Icon, type IconName } from '@/ui/components/Icon';
import { useUiImage } from './uiArt';
import styles from './SpotArt.module.css';

/**
 * A painted spot illustration from the art manifest (`ill_*`, `empty_*`, `mailbox_empty_illus`, `story_*`, gaps
 * B7). Decorative: the text beside it says the same. Until the art has loaded (or if it is missing) the matching
 * painted icon stands in, so the layout never jumps to an empty hole.
 */
export function SpotArt({
  name,
  fallback,
  size = 140,
  className,
}: {
  name: string;
  fallback: IconName;
  size?: number;
  className?: string;
}) {
  const url = useUiImage(name);
  return (
    <span
      className={`${styles.spot}${className ? ` ${className}` : ''}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      {url ? (
        <img src={url} alt="" draggable={false} className={styles.img} />
      ) : (
        <Icon name={fallback} size={Math.round(size * 0.55)} />
      )}
    </span>
  );
}
